import style from '../../../styles/Weather/weather_hourly_conditions'
import Icon from '../Icon'

import moment from 'moment'

const Hour = ({ hour, high, low }) => {
  const { temperature = '', validTimeUtc = '', iconCode = '', precipChance = '' } = hour || {}
  const difference = ((high - temperature) / (high - low)) * 50

  return (
    <div className='temp-container' style={{ marginTop: `${difference}px` }}>
      {temperature && <div className='value'>{temperature}</div>}
      <div className='vl' style={{ height: `${97 - difference}px` }} role='progressbar' />
      {validTimeUtc && <div className='time'>{moment.utc(validTimeUtc).local().format('h a')}</div>}
      <Icon style={style} iconCode={iconCode} />
      {precipChance != null && <span className='precipitation'>{precipChance}</span>}
      <style jsx>{style}</style>
    </div>
  )
}

export default Hour
